<div class="field-checkbox-group" [class]="getFieldLayoutClass()">
  <div *ngFor="let option of options; let i = index; trackBy: trackByOptionValue" class="field-checkbox-item">
    <p-checkbox
      [binary]="true"
      [ngModel]="isSelected(option.value)"
      (ngModelChange)="onCheckboxChange(option.value, $event)"
      [disabled]="disabled"
      [inputId]="getInputId(option.value)"
    ></p-checkbox>
    <label [for]="getInputId(option.value)">{{ option.label }}</label>
  </div>
</div>
